var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4167 8.04169H9.66666C8.83823 8.04169 8.16666 8.71326 8.16666 9.54169V16.2917C8.16666 17.1201 8.83823 17.7917 9.66666 17.7917H16.4167C17.2451 17.7917 17.9167 17.1201 17.9167 16.2917V9.54169C17.9167 8.71326 17.2451 8.04169 16.4167 8.04169Z",
    stroke: "#1D7777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16666 12.5417H4.41666C4.01883 12.5417 3.6373 12.3837 3.356 12.1023C3.07469 11.821 2.91666 11.4395 2.91666 11.0417V4.29169C2.91666 3.89386 3.07469 3.51233 3.356 3.23103C3.6373 2.94972 4.01883 2.79169 4.41666 2.79169H11.1667C11.5645 2.79169 11.946 2.94972 12.2273 3.23103C12.5086 3.51233 12.6667 3.89386 12.6667 4.29169V5.04169",
    stroke: "#1D7777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIc);
export default __webpack_public_path__ + "static/media/copy_ic.83e1d54dae1200679932b1d1008267e0.svg";
export { ForwardRef as ReactComponent };